<template>
  <Modal :modelValue="modelValue" @update:modelValue="emit('update:modelValue', $event)" :header="false" :disableClose="true" size="w-[480px] max-w-[calc(100vw-32px)]">
    <div class="px-2 py-1">
      <div class="flex items-center gap-3">
        <div class="flex h-12 w-12 items-center justify-center rounded-full bg-[#ffdbe3]">
          <div class="flex h-8 w-8 items-center justify-center rounded-full bg-[#ffb7c6] text-[#c82b53]">
            <IconSolid icon="fa-trash-can" />
          </div>
        </div>
        <h3 class="text-[18px] font-semibold leading-6 text-[#13161b]">
          {{ title }}
        </h3>
      </div>

      <div class="mt-6 text-[16px] leading-7 text-[#13161b]">
        <slot>
          Você deseja excluir <b v-if="itemName">"{{ itemName }}"</b><span v-else>este registro</span>?
        </slot>
      </div>
    </div>

    <template #footer>
      <div class="flex w-full justify-end gap-3 px-2 pb-1 pt-2">
        <button
          type="button"
          class="inline-flex h-[44px] min-w-[140px] items-center justify-center gap-2 rounded-[10px] border border-[#ff4d4f] bg-white px-5 text-[16px] font-medium text-[#ff4d4f] transition hover:bg-[#fff5f5]"
          @click="emit('update:modelValue', false)">
          <IconSolid icon="fa-xmark" />
          <span>Cancelar</span>
        </button>

        <button
          type="button"
          class="inline-flex h-[44px] min-w-[140px] items-center justify-center gap-2 rounded-[10px] border border-[#8ccf45] bg-[#8ccf45] px-5 text-[16px] font-medium text-[#13161b] transition hover:bg-[#81c53c]"
          @click="emit('confirm')">
          <IconSolid icon="fa-check" />
          <span>Confirmar</span>
        </button>
      </div>
    </template>
  </Modal>
</template>

<script setup>
defineProps({
  modelValue: Boolean,
  title: {
    type: String,
    default: 'Excluir Registro',
  },
  itemName: {
    type: String,
    default: null,
  },
})

const emit = defineEmits(['update:modelValue', 'confirm'])
</script>
